function importUsersDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/import-users/import-users-dialog.html?$$REVISION$$'
  }
}

export { importUsersDialogDirective }
